export const PLANT_DETAILS = () => {
  return {
    installationName: {
      key: "installationName",
      required: true,
      maxChar: 250,
    },
    description: {
      key: "description",
      multiline: "3",
      maxChar: 500,
    },
    city: {
      key: "city",
      maxChar: 100,
    },
  };
};

export const WATER_TYPE = (t) => {
  return [
    t("waterType.seawater"),
    t("waterType.surfaceWater"),
    t("waterType.wellWater"),
    t("waterType.wastewater"),
  ];
};

export const FEED_WATER_LIMIT_FIELDS = [
  {
    key: "turbidity_limit",
    labelKey: "addNewPlant.turbidityLimit",
    errorKey: "addNewPlant.turbidityLimitValidation",
    min: 1,
    max: 76,
    maxLength: 3,
  },
  {
    key: "tss_limit",
    labelKey: "addNewPlant.tssLimitUpper",
    errorKey: "addNewPlant.tssLimitValidation",
    min: 1,
    max: 51,
    maxLength: 3,
  },
  {
    key: "toc_limit",
    labelKey: "addNewPlant.tocLimit",
    errorKey: "addNewPlant.tocLimitValidation",
    min: 1,
    max: 26,
    maxLength: 3,
  },
];
